import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ButtonThemeState } from "app/shared";
import { COUNTRIES_RATES } from "./callRates";

@Component({
    selector: "dodo-international-rates-dialog",
    templateUrl: "./international-rates-dialog.component.html",
    styleUrls: ["./international-rates-dialog.component.scss"],
    standalone: false
})
export class InternationalRatesDialogComponent implements OnInit {
	form: FormGroup;
	public buttonTheme = ButtonThemeState.GREEN;
	public busy = false;
	countryExist = false;
	countries = COUNTRIES_RATES;
	results = [];
	selectedCountry: string;
	filteredCountries = COUNTRIES_RATES;
	selectedOption = [];
	constructor(
		private formBuilder: FormBuilder,
		public dialogRef: MatDialogRef<InternationalRatesDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		// const s = document.createElement("script");
		// s.type = "text/javascript";
		// s.innerHTML =
		// 	"var ua = 'UA-1639020-1'; if (gaData && gaData['UA-1639020-14']) ua = 'UA-1639020-14'; ga('create', ua, 'auto'); ga(function(tracker) { var clientId = tracker.get('clientId'); var frameWindow = document.getElementById('request-callback-iframe').contentWindow; frameWindow.postMessage(clientId, location.origin); });";
		// document.body.appendChild(s);
	}

	ngOnInit() {
		this.form = this.formBuilder.group({
			country: "",
		});
		this.form.controls.country.valueChanges.subscribe((countryData) => {
			this.results = [];
			this.filteredCountries = this.countries?.filter((option) =>
				option.Value.toLowerCase().includes(countryData.toLowerCase())
			);
			this.selectedOption = this.countries.filter((country) => country.Value === countryData);
			if (this.selectedOption && this.selectedOption.length > 0) {
				this.countryExist = true;
			} else {
				this.countryExist = false;
			}
		});
	}

	public closeDialog(): void {
		this.dialogRef.close();
	}

	handleCountrySelection(event) {
		console.log(event);
	}

	formSubmit(): void {
		this.selectedCountry = this.form?.controls?.country?.value.toLowerCase();
		this.results = this.selectedOption;
		console.log("this.results", this.results);
	}
}
